var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isActive)?_c('b-tag',{staticClass:"c-tag",class:_vm.type,attrs:{"attached":_vm.attached,"closable":_vm.closable},on:{"close":_vm.onClose}},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }